module.exports = "/_next/static/images/speaker-shapes-8917b1cc33c46232b93065a8dea1debf.png";